import { LanguageEnum } from '@models/language';

export interface ILanguageSelectorConfig {
	defaultLanguage: LanguageEnum;
}

export const LANGUAGE_SELECTOR_CONFIG: ILanguageSelectorConfig = {
	defaultLanguage: LanguageEnum.GERMAN
};
